import View from "./View";

const Comparison = ({ project, onNext }) => (
  <View project={project} onNext={onNext} />
);

export default Comparison;
